import React from 'react';

function HyperMajor(props) {
  return (
    <svg viewBox="0 0 24 24" {...props}>
      <defs>
        <linearGradient x1="-1.11022302e-14%" y1="50%" x2="100%" y2="50%" id="linearGradient">
          <stop stopColor="#099FC3" offset="0%" />
          <stop stopColor="#8008F7" offset="50%" />
          <stop stopColor="#FF54B3" offset="100%" />
        </linearGradient>
      </defs>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-1964.000000, -1006.000000)">
          <g transform="translate(1912.000000, 962.000000)">
            <g>
              <g
                transform="translate(52.000000, 44.000000)"
                fill="url(#linearGradient)"
                fillRule="evenodd"
              >
                <path d="M15.9759287,9.6685821 C19.3668379,9.6685821 22.125,12.4630555 22.125,15.8974508 C22.125,19.2542701 19.4877788,22.0004873 16.2010098,22.1208837 L15.9759287,22.125 L15.7507581,22.120884 C12.4626946,22.0004961 9.82503387,19.2544671 9.82503387,15.8974508 C9.82503387,15.4221972 10.2054098,15.0369781 10.6760798,15.0369781 C11.1469631,15.0369781 11.5273863,15.4221496 11.5273863,15.8974508 C11.5273863,18.382834 13.523407,20.4040547 15.9759287,20.4040547 C18.4278005,20.4040547 20.4229081,18.382964 20.4229081,15.8974508 C20.4229081,13.4826977 18.5399336,11.5054572 16.1849137,11.3944432 L15.9759287,11.3895274 L10.6760798,11.3895274 C10.2054928,11.3895274 9.82503387,11.0041287 9.82503387,10.5290547 C9.82503387,10.0903591 10.1491412,9.72837932 10.5691985,9.67528595 L10.6760798,9.6685821 L15.9759287,9.6685821 Z M8.02433179,1.875 C11.4161384,1.875 14.1749661,4.6690634 14.1749661,8.10228532 C14.1749661,8.57762323 13.7947677,8.96275796 13.3239202,8.96275796 C12.8530369,8.96275796 12.4726137,8.57758651 12.4726137,8.10228532 C12.4726137,5.61708639 10.4765145,3.59594527 8.02433179,3.59594527 C5.57218687,3.59594527 3.57709191,5.61678472 3.57709191,8.10228532 C3.57709191,10.5170771 5.46010343,12.4942812 7.81532826,12.605293 L8.02433179,12.6102087 L13.3239202,12.6102087 C13.7946848,12.6102087 14.1749661,12.995523 14.1749661,13.4706814 C14.1749661,13.9094887 13.8509797,14.2715988 13.4308293,14.3247116 L13.3239202,14.3314179 L8.02433179,14.3314179 C4.63342261,14.3314179 1.875,11.5366806 1.875,8.10228532 C1.875,4.66927181 4.63362183,1.875 8.02433179,1.875 Z" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default HyperMajor;
